import type { AppStrings } from './types.js';

export const ko: AppStrings = {
  // COMMON
  error_title: '오류',
  cancel: '취소',
  retry: '다시 시도',
  back_arrow: '← 뒤로',

  // ASK SCREEN
  ask_box_unavailable: '박스를 사용할 수 없어요',
  ask_box_unavailable_desc: '링크가 만료됐거나 상대방이 박스를 닫은 것 같아요.',
  ask_create_own_box: '내 박스 만들기',
  ask_sent_title: '전송됐어요 ✅',
  ask_sent_desc: '익명 질문이 박스 주인에게 전달됐어요.',
  ask_anonymous_hint: '질문은 익명으로 전송돼요.',
  ask_placeholder: '질문을 써보세요…',
  ask_send: '전송',
  ask_sending: '전송 중…',
  ask_error_rate_limit: '요청이 너무 많아요. 1분 후에 다시 시도해 주세요.',
  ask_error_restart: 'Mini App을 다시 시작해 주세요.',
  ask_error_load: '박스를 불러오지 못했어요.',
  ask_error_send: '질문을 전송하지 못했어요.',
  ask_error_banned: '앱에서 차단된 상태예요.',
  ask_banned_appeal_btn: '이의 제기',
  ask_appeal_sent: '이의 신청이 접수됐어요. 직접 검토할게요.',

  // AGE GATE
  age_gate_title: '만 18세 이상만',
  age_gate_desc:
    '익명 질문을 보내려 하고 있어요. 서로 존중해 주세요: 괴롭힘, 협박, 미성년자 관련 성적 콘텐츠 및 법률에 위반하는 콘텐츠는 금지돼요. 익명이라도 책임은 면할 수 없어요 — 위반 사항은 운영진에 보고돼요. 질문을 전송하면 만 18세 이상임을 확인하고 규칙에 동의하는 것으로 간주해요.',
  age_gate_confirm: '만 18세 이상입니다 — 계속하기',

  // INBOX SCREEN
  inbox_title: '내 박스',
  box_link_accordion: '초대 링크',
  inbox_notifications_ask: '🔔 봇이 새 질문 알림을 보내도록 허용할까요?',
  inbox_notifications_allow: '허용',
  inbox_notifications_dismiss_label: '닫기',
  inbox_box_toggle_disable: '질문 받기 끄기',
  inbox_box_toggle_enable: '질문 받기 켜기',
  inbox_box_disabled_warning: '질문 받기가 꺼져 있어요 — 새 질문을 받지 않아요.',
  inbox_share_hint: '링크를 공유해서 친구들이 익명으로 질문할 수 있게 해요.',
  inbox_copy: '복사',
  inbox_copied: '복사됐어요',
  inbox_copy_error: '오류',
  inbox_no_deeplink: '링크는 배포 후에 표시돼요.',
  inbox_invite_story: 'Story로 초대',
  inbox_invite_chat: '채팅으로 초대',
  inbox_card_rendering: '초대 카드를 만드는 중이에요.',
  inbox_story_unsupported:
    '이 버전의 Telegram에서는 Story를 지원하지 않아요. 「채팅으로」를 시도해 보세요.',
  inbox_story_error: 'Story를 열지 못했어요.',
  inbox_chat_unsupported:
    '이 버전의 Telegram에서는 채팅 공유를 지원하지 않아요. 앱을 업데이트해 주세요.',
  inbox_chat_error: '공유하지 못했어요. 다시 시도해 주세요.',
  inbox_chat_prepare_error: '초대 준비에 실패했어요.',
  inbox_filter_incoming: '받은 질문',
  inbox_filter_hidden: '숨긴 것',
  inbox_filter_blocked: '차단됨',
  inbox_filter_empty: '아직 아무것도 없어요.',
  inbox_acc_unanswered: '미답변',
  inbox_acc_answered: '답변 완료',
  inbox_acc_hidden: '숨김',
  inbox_acc_blocked: '차단됨',
  inbox_empty: '아직 질문이 없어요. 위의 링크를 공유해 보세요.',
  inbox_load_more: '더 불러오기',
  inbox_load_more_error: '다음 페이지를 불러오지 못했어요.',
  inbox_error_load: '박스를 불러오지 못했어요.',
  inbox_rate_limit: '요청이 너무 많아요. 1분 후에 다시 시도해 주세요.',
  inbox_toggle_error: '박스 상태를 변경하지 못했어요.',

  // MESSAGE BOX (Трек D)
  message_tagline: '저에게 익명으로 메시지를 보내세요',
  message_placeholder: '메시지를 써보세요…',
  message_anonymous_hint: '메시지는 익명으로 전송돼요.',
  message_sent_title: '전송됐어요 ✅',
  message_sent_desc: '익명 메시지가 전달됐어요.',
  message_owner_entry: '저에게 메시지 보내기',
  message_share_hint: '링크를 공유해서 누구나 익명으로 메시지를 보낼 수 있게 해요.',
  message_inbox_open: '받은 메시지',
  message_inbox_title: '메시지',
  message_inbox_empty: '아직 메시지가 없어요. 위의 링크를 공유해 보세요.',

  // ANSWER SCREEN
  answer_title: '질문에 답하기',
  answer_placeholder: '답변을 써보세요…',
  answer_submit: '전송',
  answer_submitting: '전송 중…',
  answer_back: '뒤로',
  answer_error_send: '답변을 전송하지 못했어요.',

  // SHARE SCREEN
  share_title: '답변이 게시됐어요 ✅',
  share_hint: '카드를 공유해서 더 많은 질문을 받아보세요.',
  share_card_rendering_desc:
    '카드가 아직 만들어지고 있어요. 질문 목록으로 돌아가서 잠시 후 다시 확인해 보세요 — Story나 채팅에서 공유할 수 있게 돼요.',
  share_card_alt: '답변 카드',
  share_story_btn: 'Story에 공유',
  share_story_btn_busy: '열고 있어요…',
  share_chat_btn: '채팅에 공유',
  share_chat_btn_busy: '준비 중…',
  share_back: '질문으로 돌아가기',
  share_story_unsupported:
    '이 버전의 Telegram에서는 Story를 지원하지 않아요. 「채팅에 공유」를 시도해 보세요.',
  share_story_error: 'Story를 열지 못했어요. 「채팅에 공유」를 시도해 보세요.',
  share_chat_sent: '메시지를 보냈어요.',
  share_chat_unsupported:
    '이 버전의 Telegram에서는 채팅 공유를 지원하지 않아요. 앱을 업데이트해 주세요.',
  share_chat_error: '공유하지 못했어요. 다시 시도해 주세요.',
  share_chat_prepare_error: '메시지 준비에 실패했어요.',

  // LEADERBOARD SCREEN
  lb_title: '리더보드',
  lb_period_7d: '7일',
  lb_period_30d: '30일',
  lb_period_all: '전체 기간',
  lb_group_label: '카테고리',
  lb_group_all: '전체',
  lb_group_ask: '질문',
  lb_group_rate: '평가',
  lb_group_confession: '고백',
  lb_group_guesswho: '나는 누구',
  lb_group_message: '메시지',
  lb_error: '리더보드를 불러오지 못했어요',
  lb_empty: '아직 순위에 아무도 없어요',
  lb_anon: '익명',
  lb_load_more: '더 불러오기',
  lb_questions: (n) => `질문 ${n}개`,
  lb_referrals: (n) => `추천 ${n}건`,

  // REWARDS SCREEN
  rw_title: '내 보상',
  rw_error: '보상을 불러오지 못했어요',
  rw_level: (n) => `레벨 ${n}`,
  rw_confirmed_referrals: (n) => `확인된 추천 ${n}명`,
  rw_next_level_section: (n) => `다음 레벨 — 추천 ${n}명`,
  rw_to_level: (level, target) => `레벨 ${level}까지: ${target}명 더`,
  rw_max_level: '최고 레벨에 도달했어요!',
  rw_badges_section: '배지',
  rw_formats_section: '박스 스타일',

  // QUESTION CARD
  qcard_status_new: '새 질문',
  qcard_status_hidden: '숨김',
  qcard_status_answered: '답변 완료',
  qcard_moderation_flagged: '주의: 의심스러운 메시지',
  qcard_answer_btn: '답하기',
  qcard_answer_send: '전송',
  qcard_share_btn: '공유',
  qcard_hide_btn: '숨기기',
  qcard_show_btn: '보이기',
  qcard_report_btn: '신고',
  qcard_block_btn: '차단',
  qcard_unblock_btn: '차단 해제',
  qcard_report_reason_label: '신고 사유를 선택하세요:',
  qcard_reason_spam: '스팸',
  qcard_reason_harassment: '괴롭힘',
  qcard_reason_sexual: '성적 콘텐츠',
  qcard_reason_other: '기타',
  qcard_error_hide: '표시 설정을 변경하지 못했어요.',
  qcard_error_report: '신고를 전송하지 못했어요.',
  qcard_error_block: '발신자를 차단하지 못했어요.',
  qcard_report_done: '신고가 접수됐어요 — 감사해요.',
  qcard_block_done: '발신자가 차단됐어요.',
  qcard_unblock_done: '차단이 해제됐어요.',

  // ERRORS
  err_network: '서버에 연결할 수 없어요. 인터넷 연결을 확인하고 다시 시도해 주세요.',
  err_server_unavailable: '서버가 일시적으로 이용 불가예요. 잠시 후 다시 시도해 주세요.',
  err_internal: '문제가 발생했어요. 이미 확인 중이에요 — 잠시 후 다시 시도해 주세요.',
  err_bad_request: '입력한 내용을 확인해 주세요.',
  err_generic: '작업을 완료하지 못했어요. 잠시 후 다시 시도해 주세요.',
  err_schema: '데이터 오류가 발생했어요. 앱을 업데이트해 보세요.',
  share_story_link_premium_note:
    'Story의 클릭 가능한 링크는 Telegram Premium이 필요해요. Premium이 없어도 괜찮아요 — 카드에 사용자 이름이 표시돼요.',

  // AUTH ERROR SCREEN
  auth_error_title: '접근 오류',
  auth_error_desc:
    '인증에 실패했어요. Telegram에서 Mini App을 닫고 다시 열어 주세요.',

  // REWARD TOAST
  reward_toast_title: '새 보상!',
  reward_toast_close: '×',

  // BOTTOM TABBAR
  tab_questions: '질문',
  tab_leaderboard: '리더보드',
  tab_rewards: '보상',
  tab_settings: '설정',

  // SETTINGS SCREEN
  settings_title: '설정',
  settings_section_general: '일반',
  settings_notifications: '새 질문 알림',
  settings_notifications_hint: '누군가 질문하면 봇이 메시지를 보내줘요.',
  settings_notifications_error: '알림 설정을 저장하지 못했어요.',
  settings_language: '언어',
  settings_language_error: '언어를 변경하지 못했어요. 다시 시도해 주세요.',
  settings_section_about: '앱 정보',
  settings_version: '버전',

  // CODE ENTRY (work-020)
  code_modal_title: 'Story 링크는 Premium 전용',
  code_modal_explain:
    'Telegram은 클릭 가능한 Story 링크를 Premium 구독자에게만 제공해요. 대신 Story에 코드를 추가해 보세요 — 방문자가 앱에 코드를 입력하면 익명으로 질문할 수 있어요.',
  code_modal_your_code: '내 코드',
  code_modal_copy: '코드 복사',
  code_modal_copied: '복사됐어요',
  code_modal_share_btn: 'Story에 공유',
  code_modal_loading: '코드 불러오는 중…',
  code_modal_error: '코드를 가져오지 못했어요. 나중에 다시 시도해 주세요.',
  ask_code_title: '코드 입력',
  ask_code_desc: 'Story에서 왔나요? Story의 코드(예: 1234)를 찾아 아래에 입력해 주세요.',
  ask_code_placeholder: 'Story의 코드',
  ask_code_find: '찾기',
  ask_code_not_found: '코드를 찾지 못했어요. 숫자를 확인하고 다시 시도해 주세요.',
  ask_code_invalid: '코드는 4자리 숫자예요.',
  code_onboarding_header: 'Story에서 왔나요?',
  code_onboarding_text: '친구의 코드를 입력해서 익명으로 질문해 보세요.',
  code_onboarding_action: '코드 입력',
  settings_ask_by_code: '코드로 질문',
  settings_my_code_title: '내 Story 코드',
  settings_my_code_hint:
    '이 코드를 Story에 써두면 방문자들이 앱에 입력해 익명으로 질문할 수 있어요. 클릭 가능한 Story 링크는 Telegram Premium 구독자만 이용할 수 있어요.',
  settings_my_code_rotate: '새 코드 받기',
  settings_my_code_rotating: '업데이트 중…',
  settings_my_code_done: '코드가 업데이트됐어요',
  settings_my_code_error: '코드를 가져오지 못했어요.',
  settings_my_code_rotate_confirm_title: '코드를 바꿀까요?',
  settings_my_code_rotate_confirm_desc:
    '기존 코드는 바로 작동을 멈춰요. Story에서 코드를 본 사람은 더 이상 나에게 질문을 보낼 수 없어요. 누가 도배할 때만 바꾸는 게 좋아요.',
  settings_my_code_rotate_confirm_action: '코드 바꾸기',

  // BOT
  bot_greeting: (name) => (name ? `안녕하세요, ${name}! 👋` : '안녕하세요! 👋'),
  bot_onboarding:
    '이것은 VeylMe — 익명 질문 서비스입니다.\n\n' +
    'Mini App을 열고, Story에 «익명으로 질문해 주세요» 카드를 게시하세요 — ' +
    '익명 질문이 바로 여기로 도착합니다.\n\n' +
    '⚠️ 18+. 예의를 지켜주세요: 괴롭힘, 위협, 금지된 콘텐츠는 ' +
    '허용되지 않습니다. 익명 ≠ 면책 — 위반 사항은 모더레이션으로 보고됩니다.',
  bot_open_btn: 'VeylMe 열기',
  notify_answer_btn: '답변하기',
  bot_invite_text:
    '누군가 VeylMe 링크를 공유했어요.\n\n' +
    'Mini App을 열어 익명으로 질문해 보세요:',
  bot_invite_btn: '익명으로 질문하기',

  // WORK-027 i18n sweep
  tagline: '저에게 익명으로 질문하세요',
  share_ask_action: '질문하기',
  share_answered_text: '익명 질문에 답했어요 👀',
  err_not_in_telegram: 'Mini App이 Telegram 안에서 실행되고 있지 않아요. 앱을 다시 시작해 주세요.',
  badge_viral_starter: '바이럴 시작',
  badge_storyteller: '스토리텔러',
  badge_loop_master: '루프 마스터',
  theme_confession: '고백',
  theme_guesswho: '나는 누구',
  rw_format_named: (name) => `형식 「${name}」`,
  card_label_question: '질문',
  card_label_answer: '답변',
  card_invite_subtitle: '익명, 가입 불필요',
  card_code_hint: '앱에 코드를 입력하세요',
  share_msg_title: (brand) => `${brand} · 익명 질문`,
  notify_new_question: '🔔 익명의 질문이 도착했어요',
  notify_unanswered_reminder: (n) => `🔔 답하지 않은 질문이 ${n}개 있어요`,
  notify_ban_permanent: '영구적으로',
  notify_ban_until: (date) => `${date}까지`,
  notify_ban_msg: (untilPhrase) =>
    `⛔ VeylMe에서 ${untilPhrase} 차단됐어요. 너무 많은 수신자가 당신의 메시지를 신고했어요.\n실수라고 생각되면 앱에서 이의를 제기할 수 있어요.`,
  notify_warning_msg: '⚠️ 여러 수신자가 당신의 메시지를 신고했어요. 조금만 더 하면 VeylMe에서 차단돼요.',

  // MY QUESTIONS SCREEN + InvitePanel non-premium hint (retention-answer-loop)
  my_questions_title: '내 질문',
  my_questions_empty_title: '아직 질문한 적이 없어요',
  my_questions_empty_desc: '누군가의 상자에 질문을 남겨보세요 — 답변이 여기에 표시돼요.',
  my_questions_loading: '답변 확인 중…',
  my_questions_waiting: '답변 대기 중',
  my_questions_answer_label: '답변',
  settings_my_questions: '내 질문',
  ask_sent_find_reply_hint: '답변은 나중에 «내 질문»에서 확인할 수 있어요.',
  inbox_story_nonpremium_hint: 'Telegram Premium이 없으면 스토리 링크를 탭할 수 없어서 대신 코드를 보여줘요 — 채팅 공유가 더 확실해요.',

  // SESSION EXPIRY SCREEN (work-038)
  session_expired_title: 'Telegram 접속 권한이 만료됐어요',
  session_expired_desc: 'Telegram은 앱에 접속 권한을 실행할 때 한 번만 발급해요. 이 권한은 이미 만료됐어요. 앱을 다시 열어주세요 — 쓰던 내용은 저장해 뒀어요.',
  session_expired_desc_no_storage: 'Telegram 접속 권한이 만료되어 앱을 다시 열어야 해요. 입력하신 내용을 저장하지 못했어요 — 나가기 전에 복사해 두세요.',
  session_expired_reopen: '다시 열기',
  session_expired_stuck_title: 'Telegram이 같은 예전 권한을 돌려줬어요',
  session_expired_stuck_desc: '봇 메뉴에서 앱을 완전히 닫고 다시 열어주세요 — 그러면 Telegram이 새 권한을 발급해요.',
  session_auth_failed_title: '로그인을 확인하지 못했어요',
  session_auth_failed_desc: 'Telegram이 앱 로그인을 확인해 주지 않았어요. 앱을 닫고 봇과의 채팅에서 다시 열어주세요.',
  session_expired_manual_close: '여기서는 앱이 스스로 닫힐 수 없어요 — 직접 닫고 봇과의 채팅에서 다시 열어주세요.',
  session_expiring_soon: 'Telegram 접속 권한이 곧 만료돼요. 아무것도 잃지 않도록 앱을 다시 열어주세요.',
  my_questions_check_failed: '답변을 확인하지 못했어요. 잠시 뒤에 다시 시도해 주세요.',
  settings_notifications_load_error: '설정을 불러오지 못했어요.',
};
